export const makeAbstractMethod = (name: string) => ((...args: Array<any>) => { throw new Error(`${name} not implemented`)});